import { baseBlockBodyClasses } from '@ContractBuilder/modules/block/classes';
import { BLOCK_ACTIONS_Z_INDEX } from '@root/src/constants/z-indices';
import clsx from 'clsx';

import type { BlockCreatorStepId } from './types';

// The wysiwyg step zeroes padding on both wrappers: the outer one carries py-3 (via
// baseBlockBodyClasses), the inner one pb-8.
export const blockCreatorClasses = (step: BlockCreatorStepId) =>
  clsx(
    baseBlockBodyClasses,
    'border-info-300 border-l-primary-500 z-16 bg-primary-50/50 h-auto border-b border-l-4 px-0!',
    step === 'wysiwyg' && 'p-0!',
  );

export const blockCreatorViewClasses = (step: BlockCreatorStepId) =>
  clsx(
    'flex w-full min-h-[370px] flex-col gap-10 pb-8',
    (step === 'start' || step === 'block') && 'not-prose',
    step === 'wysiwyg' && 'min-h-min p-0!',
  );

export const addIconClasses = clsx(
  'text-primary-500 invisible absolute bottom-0 left-0 flex w-full translate-y-1/2 cursor-pointer items-center opacity-0 transition duration-500 ease-in-out group-hover:pointer-events-auto group-hover:visible group-hover:opacity-100',
  BLOCK_ACTIONS_Z_INDEX,
);
